import styled from 'styled-components';
export const StyledContainer = styled.div `
    width: 100%;
    height: 100%;

    * {
        font-family: ${props => props.theme.fontBase};
    }
`;
